<template>
  <div>
    <vs-select
      class="selectExample"
      label="Dashboard Select"
      v-model="select1"
      >
      <vs-select-item :key="index" :value="item.link" :text="item.name" v-for="(item,index) in dashboardlist" />
    </vs-select><br>
    <iframe :src="select1" name="iframe_a" :height="height" width="100%" title="Iframe Example"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data: () => ({
    user:'',
    dashboardlist: [],
    select1: '',
    height: 0,
    token: ''
  }),
  methods: {
      
  },
  mounted() {
    this.user = this.$session.get('username')
    this.token = this.$session.get('token')
    this.$http.get(this.$url+'dashboardlist/'+this.token).then((result) => {
      console.log(result.data)
      this.dashboardlist = result.data[0].list
    })
    this.height = window.innerHeight
  }
}
</script>

<style>

</style>